/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

export const ColStyled = styled(Col)`
  && {
    ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${rem(16)};
      max-width: ${mediumUp ? '100%' : rem(480)};
    `;
  }}
}`;

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      justify-content: ${mediumUp ? 'flex-start' : 'center'};
    `;
  }
}`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? rem(44) : rem(32)};
    `;
  }
}`;
